import React, { useState } from 'react';
import { GetAccount, isLogged } from '../../Services/Authentication';
import { GenerateImage } from '../../Services/Genertae';
import { useNavigate } from 'react-router-dom';
import { Generate } from '../../Models/Generate';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const GenerateImages: React.FunctionComponent<{}> = (props) => {



	const [generateObj, setGenerateObj] = useState<Generate>({
		"environment": "interior",
		"room_type": "",
		"property_type": "",
		"style": "",
		"level": "",
		"number_generations": "",
		"instructions": "",
		"images": [],
		"custom_instructions": false
	});
	const [roomType, setRomeType] = useState<any>([{ value: "Bedroom", type: "Bedroom" },
	{ value: "Bathroom", type: "Bathroom" },
	{ value: "Living Room", type: "Living Room" },
	{ value: "Kitchen", type: "Kitchen" }, { value: "Balcony", type: "Balcony" },
	{ value: "Office Room", type: "Office Room" }, { value: "Dining Area", type: "Dining Area" },
	{ value: "Terrace", type: "Terrace" }])
	const [style, setStyle] = useState<any>([{ value: "Eclectic", type: "Eclectic" },
	{ value: "Cottage", type: "Cottage" },
	{ value: "Scandinavian", type: "Scandinavian" },
	{ value: "Coastal", type: "Coastal" }, { value: "Traditional", type: "Traditional" },
	{ value: "Bohemian", type: "Bohemian" }, { value: "Art Deco", type: "Art Deco" },
	{ value: "Contemporary", type: "Contemporary" },
	{ value: "Modern", type: "Modern" }, { value: "Midcentury Modern", type: "Midcentury Modern" },
	{ value: "Country", type: "Country" }, { value: "Shabby Chic", type: "Shabby Chic" },
	{ value: "Modern Farmhouse", type: "Modern Farmhouse" }, { value: "Americana", type: "Americana" },
	{ value: "French Country", type: "French Country" }, { value: "Transitional", type: "Transitional" },
	{ value: "Hollywood Regency", type: "Hollywood Regency" }, { value: "Chinoiserie", type: "Chinoiserie" },
	{ value: "Mediterranean", type: "Mediterranean" }, { value: "Tropical", type: "Tropical" },
	{ value: "Minimalist", type: "Minimalist" }, { value: "Maximalist", type: "Maximalist" },
	{ value: "Rustic", type: "Rustic" }, { value: "Romantic", type: "Romantic" },
	{ value: "Asian", type: "Asian" }])
	const [styleGarden, setStyleGarden] = useState<any>([{ value: "Japanese Zen Garden", type: "Japanese Zen Garden" },
	{ value: "Mediterranean Garden", type: "Mediterranean Garden" },
	{ value: "Formal French Garden", type: "Formal French Garden" },
	{ value: "Tropical Garden", type: "Tropical Garden" }, { value: "Desert Garden", type: "Desert Garden" },
	{ value: "Modern/Contemporary Garden", type: "Modern/Contemporary Garden" }, { value: "Wildflower Meadow", type: "Wildflower Meadow" },
	{ value: "Cottage Garden", type: "Cottage Garden" },
	{ value: "Rock Garden", type: "Rock Garden" }, { value: "Xeriscape Garden", type: "Xeriscape Garden" },
	{ value: "Native Plant Garden", type: "Native Plant Garden" }, { value: "English Cottage Garden", type: "English Cottage Garden" }])
	const [styleExtVilla, setStyleExtVilla] = useState<any>([{ value: "Modern Villa", type: "Modern Villa" },
	{ value: "Mediterranean Villa", type: "Mediterranean Villa" }, { value: "Colonial Style Mansion", type: "Colonial Style Mansion" },
	{ value: "Traditional Villa", type: "Traditional Villa" }, { value: "Cottage-Style Home", type: "Cottage-Style Home" },{value:"Rustic Country House",type:"Rustic Country House"},
	{value:"Eco-friendly Villa",type:"Eco-friendly Villa"},{value:"Compact Tiny Home",type:"Compact Tiny Home"},{value:"Exquisite Manor",type:"Exquisite Manor"},{value:"Beachfront Retreat",type:"Beachfront Retreat"},{value:"Traditional Farmhouse",type:"Traditional Farmhouse"}])
	const [styleExtBuil, setStyleExtBuil] = useState<any>([{ value: "Contemporary High-rise", type: "Contemporary High-rise" }, { value: "Minimalist Modern Building", type: "Minimalist Modern Building" },
	{ value: "Art Deco Building", type: "Art Deco Building" }, { value: "Luxury High-rise", type: "Luxury High-rise" },{ value: "Modern Apartment Complex", type: "Modern Apartment Complex" },{ value: "Sustainable Building",type: "Sustainable Building" },
	{ value: "Industrial Warehouse",type: "Industrial Warehouse" },{ value: "Futuristic Building",type: "Futuristic Building" },
	{ value: "Contemporary Loft",type: "Contemporary Loft" },{ value: "Mid-Century Modern",type: "Mid-Century Modern" }])
	const [propertyType, setPropertyType] = useState<any>([{ value: "Villa/House", type: "Villa/House" }, { value: "Building", type: "Building" }])
	const [levelValue, setLevelValue] = useState<any>([{ value: "Medium", type: "Medium" }])
	let navigate = useNavigate();
	const [selectedImages, setSelectedImages] = useState<any>("");


	const handleChangeRoomType = (event: any) => {
		setGenerateObj((prevFormData: any) => ({
			...prevFormData,
			room_type: event.target.value,
		}))
	}
	const handleChangeEnvironment = (value: any) => {
		setGenerateObj((prevFormData: any) => ({
			...prevFormData,
			environment: value,
		}))
	}

	const handleChangeLevel = (event: any) => {
		setGenerateObj((prevFormData: any) => ({
			...prevFormData,
			level: event.target.value,
		}))
	}

	const handleChangeStyle = (event: any) => {
		setGenerateObj((prevFormData: any) => ({
			...prevFormData,
			style: event.target.value,
		}))
	}

	const handleChangeNmbGenerations = (event: any) => {
		setGenerateObj((prevFormData: any) => ({
			...prevFormData,
			number_generations: event.target.value,
		}))
	}
	const handleChangeInstructions = (event: any) => {
		setGenerateObj((prevFormData: any) => ({
			...prevFormData,
			custom_instructions: event.target.checked,
		}))
	}
	const handleChangePropertyType = (event: any) => {
		setGenerateObj((prevFormData: any) => ({
			...prevFormData,
			property_type: event.target.value,
		}))
	}
	const navigateToLogin = (path: any) => {
		const fullPath = window.location.origin + path;
		window.location.href = fullPath;
	};

	const handleFileUpload = (event: any) => {
		const files = event.target.files;
		const images_List: any = []
		for (let i = 0; i < files.length; i++) {
			const reader = new FileReader();
			reader.readAsDataURL(event.target.files[i]);
			reader.onload = () => {
				const base_64 = reader.result as string;
				const ext = event.target.files[i].type.split('/');
				let image = {
					"id": i,
					"src": base_64,
					"ext": ext[1]
				}
				images_List.push(image)
				setSelectedImages((prevSelectedImages: any) =>
					[...prevSelectedImages, image]
				);

			};
		}
		setGenerateObj((prevFormData: any) => ({
			...prevFormData,
			images: images_List,
		}))
	}

	const generate = () => {
		const genr_obj = {
			"environment": generateObj.environment,
			"room_type": generateObj.room_type,
			"style": generateObj.style,
			"level": generateObj.level,
			"number_generations": generateObj.number_generations,
			"instructions": generateObj.instructions,
			"images": generateObj.images?.slice(0, 1),
			"custom_instructions": generateObj.custom_instructions
		}

		if (isLogged()) {
			navigate(`/redesign`, { state: genr_obj })
			window.location.reload()

		} else {
			navigateToLogin('/login-en#login');
		}
	}

	return (
		<div className='service-sec' id="upload-images">
			<div className=" container">
				<div className="card-upload">
					<div className="row">
						<h3 className="redisign-h3 mb-4 font-sec-4" >
							Try Nesmah Now</h3>
					</div>
					<div className="row">
						<div className=" col-md-7">
							{generateObj.images && generateObj.images.length == 0 ?
								<label id="upload-photo">
									<svg width="50" height="50" viewBox="0 0 80 80" fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M60 42.5H20C18.6333 42.5 17.5 41.3667 17.5 40C17.5 38.6333 18.6333 37.5 20 37.5H60C61.3667 37.5 62.5 38.6333 62.5 40C62.5 41.3667 61.3667 42.5 60 42.5Z"
											fill="white" />
										<path
											d="M40 62.5C38.6333 62.5 37.5 61.3667 37.5 60V20C37.5 18.6333 38.6333 17.5 40 17.5C41.3667 17.5 42.5 18.6333 42.5 20V60C42.5 61.3667 41.3667 62.5 40 62.5Z"
											fill="white" />
									</svg>
									<h3 className="upload-h3">Upload Photo </h3>
									<p className="desc-upload">Drop files here or click browse thorough your machine</p>
									<input className="form__file" id="upload-images" accept="image/*" type="file" multiple
										onChange={handleFileUpload} />
								</label>
								:
								<div id="read-photo">
									{generateObj.images && generateObj.images.map((image: any, index: any) => {
										return <img src={image.src} id="previewImage" key={index} />
									})
									}
								</div>}
						</div>
						<div className="col-md-5">
							<h2>Customize</h2>
							<label htmlFor="environment" className="label">Environment</label>
							<div className="btn-group" id="environment">
								<button type="button" className={`btn ${generateObj.environment === "interior" ? "active" : ""}`} onClick={() => handleChangeEnvironment("interior")} >
									<svg width="26" height="25" viewBox="0 0 26 25" fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path d="M4.77777 12.4304H21.4444" stroke="#08261B" strokeWidth="1.6"
											strokeLinecap="round" strokeLinejoin="round" />
										<path d="M6.44446 20.2082V12.4304" stroke="#08261B" strokeWidth="1.6"
											strokeLinecap="round" strokeLinejoin="round" />
										<path d="M19.7778 20.2082V12.4304" stroke="#08261B" strokeWidth="1.6"
											strokeLinecap="round" strokeLinejoin="round" />
										<path
											d="M6.44446 12.4304H19.7778V16.8749C19.7778 17.7954 19.0317 18.5415 18.1111 18.5415H8.11112C7.19057 18.5415 6.44446 17.7954 6.44446 16.8749V12.4304Z"
											stroke="#08261B" strokeWidth="1.6" strokeLinecap="round"
											strokeLinejoin="round" />
										<path d="M17.5555 11.8748V8.5415" stroke="#08261B" strokeWidth="1.6"
											strokeLinecap="round" strokeLinejoin="round" />
										<path d="M16.4444 5.20825H18.6666L19.7778 9.09714H15.3333L16.4444 5.20825Z"
											stroke="#08261B" strokeWidth="1.6" strokeLinecap="round"
											strokeLinejoin="round" />
										<path d="M8.11108 9.65259H10.8889V12.4304H8.11108V9.65259Z" stroke="#08261B"
											strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
										<path d="M9.10664 9.6682L8.11108 7.43042" stroke="#08261B" strokeWidth="1.6"
											strokeLinecap="round" strokeLinejoin="round" />
									</svg>Interior
								</button>
								<button type="button" className={`btn ${generateObj.environment === "Exterior" ? "active" : ""}`} onClick={() => handleChangeEnvironment("Exterior")} >
									<svg width="25" height="25" viewBox="0 0 25 25" fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M18.6111 11.5316V7.59554H19.1666V12.6428V12.7578L19.2477 12.8394L20.5555 14.1466L20.1627 14.54L19.6405 14.0178L19.1666 13.5428V14.2139V14.54C19.1666 14.8955 19.0333 15.2194 18.8133 15.4655L18.6472 15.6505L18.8127 15.8361C19.0155 16.0622 19.1444 16.3544 19.1639 16.6761L19.1666 16.7661V17.3178C19.1666 17.6733 19.0333 17.9972 18.8133 18.2433L18.6472 18.4283L18.8127 18.6139C19.0155 18.84 19.1444 19.1322 19.1639 19.4539L19.1666 19.5439V20.0955C19.1666 20.8339 18.5905 21.4378 17.8633 21.4816L17.7739 21.4844H6.66663C5.9283 21.4844 5.32441 20.9083 5.28052 20.1811L5.27774 20.0911V19.54C5.27774 19.1839 5.41108 18.86 5.63108 18.6139L5.79719 18.4289L5.63108 18.2433C5.42885 18.0172 5.29997 17.725 5.28052 17.4033L5.27774 17.3133V16.7622C5.27774 16.4061 5.41108 16.0822 5.63108 15.8361L5.79719 15.6511L5.63108 15.4655C5.43441 15.2455 5.30663 14.9628 5.28219 14.6505L5.27774 14.5344V14.2139V13.5433L4.8033 14.0178L4.28163 14.54L3.88885 14.1472L11.24 6.79554C11.7594 6.27609 12.5889 6.25442 13.1339 6.72998L13.2072 6.79887L18.1366 11.7283L18.6111 12.2022V11.5316ZM9.72219 18.9839V18.7061H9.44441L6.66663 18.7066C6.23885 18.7066 5.88719 19.0283 5.83885 19.4428L5.83774 19.4511L5.83719 19.4589L5.83385 19.5239L5.8333 19.5316V19.54V20.0955C5.8333 20.5228 6.15497 20.875 6.56997 20.9233L6.57774 20.9239L6.58552 20.9244L6.65052 20.9283L6.6583 20.9289H6.66663H9.44441H9.72219V20.6511V18.9839ZM14.1666 15.6511V15.3733H13.8889H10.5555H10.2777V15.6511V20.6511V20.9289H10.5555H13.8889H14.1666V20.6511V15.6511ZM17.7939 18.7066H17.7855H17.7777L15 18.7061H14.7222V18.9839V20.6511V20.9289H15H17.7777C18.205 20.9289 18.5572 20.6066 18.6055 20.1922L18.6061 20.1844L18.6066 20.1761L18.6105 20.1111L18.6111 20.1033V20.0955V19.54C18.6111 19.1122 18.2894 18.76 17.8744 18.7122L17.8666 18.7111L17.8583 18.7105L17.7939 18.7066ZM17.7939 15.9289H17.7855H17.7777L15 15.9283H14.7222V16.2061V17.8728V18.1505H15L17.7777 18.1511C18.205 18.1511 18.5572 17.8289 18.6055 17.4144L18.6061 17.4066L18.6066 17.3983L18.6105 17.3333L18.6111 17.3255V17.3178V16.7622C18.6111 16.3344 18.2894 15.9822 17.8744 15.9344L17.8666 15.9333L17.8583 15.9328L17.7939 15.9289ZM9.72219 16.2061V15.9283H9.44441L6.66663 15.9289C6.23885 15.9289 5.88719 16.2505 5.83885 16.665L5.83774 16.6733L5.83719 16.6811L5.83385 16.7461L5.8333 16.7539V16.7622V17.3178C5.8333 17.745 6.15497 18.0972 6.56997 18.1455L6.57774 18.1461L6.58552 18.1466L6.65052 18.1505L6.6583 18.1511H6.66663L9.44441 18.1505H9.72219V17.8728V16.2061ZM5.83885 13.8872L5.83774 13.8955L5.83719 13.9033L5.83385 13.9683L5.8333 13.9761V13.9844V14.54C5.8333 14.9672 6.15497 15.3194 6.56997 15.3678L6.57774 15.3683L6.58552 15.3689L6.65052 15.3728L6.6583 15.3733H6.66663L9.5933 15.3728H9.7533L9.8333 15.2339C9.96774 15.0028 10.2089 14.8422 10.4883 14.82L10.5605 14.8178H13.8889C14.1966 14.8178 14.4661 14.9844 14.6105 15.2344L14.6911 15.3728H14.8511L17.7777 15.3733C18.205 15.3733 18.5572 15.0511 18.6055 14.6366L18.6061 14.6289L18.6066 14.6205L18.6105 14.5555L18.6111 14.5478V14.54V13.9844C18.6111 13.5239 18.2377 13.1511 17.7777 13.1511H6.66663C6.23885 13.1511 5.88719 13.4728 5.83885 13.8872ZM16.0772 10.4539L15.9961 10.3728H15.8811H8.5633H8.4483L8.36663 10.4539L6.69997 12.1205L6.22608 12.595H6.89663H17.5477H18.2183L17.7439 12.1205L16.0772 10.4539ZM11.7111 7.11942L11.7044 7.12498L11.6977 7.13054L11.6455 7.17665L11.6389 7.1822L11.6327 7.18831L9.47774 9.34276L9.0033 9.8172H9.67441H14.77H15.4405L14.9661 9.34276L12.8111 7.18831C12.5105 6.88776 12.0383 6.86498 11.7111 7.11942Z"
											fill="#08261B" />
										<path
											d="M18.6111 11.5316V7.59554H19.1666V12.6428V12.7578L19.2477 12.8394L20.5555 14.1466L20.1627 14.54L19.6405 14.0178L19.1666 13.5428V14.2139V14.54C19.1666 14.8955 19.0333 15.2194 18.8133 15.4655L18.6472 15.6505L18.8127 15.8361C19.0155 16.0622 19.1444 16.3544 19.1639 16.6761L19.1666 16.7661V17.3178C19.1666 17.6733 19.0333 17.9972 18.8133 18.2433L18.6472 18.4283L18.8127 18.6139C19.0155 18.84 19.1444 19.1322 19.1639 19.4539L19.1666 19.5439V20.0955C19.1666 20.8339 18.5905 21.4378 17.8633 21.4816L17.7739 21.4844H6.66663C5.9283 21.4844 5.32441 20.9083 5.28052 20.1811L5.27774 20.0911V19.54C5.27774 19.1839 5.41108 18.86 5.63108 18.6139L5.79719 18.4289L5.63108 18.2433C5.42885 18.0172 5.29997 17.725 5.28052 17.4033L5.27774 17.3133V16.7622C5.27774 16.4061 5.41108 16.0822 5.63108 15.8361L5.79719 15.6511L5.63108 15.4655C5.43441 15.2455 5.30663 14.9628 5.28219 14.6505L5.27774 14.5344V14.2139V13.5433L4.8033 14.0178L4.28163 14.54L3.88885 14.1472L11.24 6.79554C11.7594 6.27609 12.5889 6.25442 13.1339 6.72998L13.2072 6.79887L18.1366 11.7283L18.6111 12.2022V11.5316ZM9.72219 18.9839V18.7061H9.44441L6.66663 18.7066C6.23885 18.7066 5.88719 19.0283 5.83885 19.4428L5.83774 19.4511L5.83719 19.4589L5.83385 19.5239L5.8333 19.5316V19.54V20.0955C5.8333 20.5228 6.15497 20.875 6.56997 20.9233L6.57774 20.9239L6.58552 20.9244L6.65052 20.9283L6.6583 20.9289H6.66663H9.44441H9.72219V20.6511V18.9839ZM14.1666 15.6511V15.3733H13.8889H10.5555H10.2777V15.6511V20.6511V20.9289H10.5555H13.8889H14.1666V20.6511V15.6511ZM17.7939 18.7066H17.7855H17.7777L15 18.7061H14.7222V18.9839V20.6511V20.9289H15H17.7777C18.205 20.9289 18.5572 20.6066 18.6055 20.1922L18.6061 20.1844L18.6066 20.1761L18.6105 20.1111L18.6111 20.1033V20.0955V19.54C18.6111 19.1122 18.2894 18.76 17.8744 18.7122L17.8666 18.7111L17.8583 18.7105L17.7939 18.7066ZM17.7939 15.9289H17.7855H17.7777L15 15.9283H14.7222V16.2061V17.8728V18.1505H15L17.7777 18.1511C18.205 18.1511 18.5572 17.8289 18.6055 17.4144L18.6061 17.4066L18.6066 17.3983L18.6105 17.3333L18.6111 17.3255V17.3178V16.7622C18.6111 16.3344 18.2894 15.9822 17.8744 15.9344L17.8666 15.9333L17.8583 15.9328L17.7939 15.9289ZM9.72219 16.2061V15.9283H9.44441L6.66663 15.9289C6.23885 15.9289 5.88719 16.2505 5.83885 16.665L5.83774 16.6733L5.83719 16.6811L5.83385 16.7461L5.8333 16.7539V16.7622V17.3178C5.8333 17.745 6.15497 18.0972 6.56997 18.1455L6.57774 18.1461L6.58552 18.1466L6.65052 18.1505L6.6583 18.1511H6.66663L9.44441 18.1505H9.72219V17.8728V16.2061ZM5.83885 13.8872L5.83774 13.8955L5.83719 13.9033L5.83385 13.9683L5.8333 13.9761V13.9844V14.54C5.8333 14.9672 6.15497 15.3194 6.56997 15.3678L6.57774 15.3683L6.58552 15.3689L6.65052 15.3728L6.6583 15.3733H6.66663L9.5933 15.3728H9.7533L9.8333 15.2339C9.96774 15.0028 10.2089 14.8422 10.4883 14.82L10.5605 14.8178H13.8889C14.1966 14.8178 14.4661 14.9844 14.6105 15.2344L14.6911 15.3728H14.8511L17.7777 15.3733C18.205 15.3733 18.5572 15.0511 18.6055 14.6366L18.6061 14.6289L18.6066 14.6205L18.6105 14.5555L18.6111 14.5478V14.54V13.9844C18.6111 13.5239 18.2377 13.1511 17.7777 13.1511H6.66663C6.23885 13.1511 5.88719 13.4728 5.83885 13.8872ZM16.0772 10.4539L15.9961 10.3728H15.8811H8.5633H8.4483L8.36663 10.4539L6.69997 12.1205L6.22608 12.595H6.89663H17.5477H18.2183L17.7439 12.1205L16.0772 10.4539ZM11.7111 7.11942L11.7044 7.12498L11.6977 7.13054L11.6455 7.17665L11.6389 7.1822L11.6327 7.18831L9.47774 9.34276L9.0033 9.8172H9.67441H14.77H15.4405L14.9661 9.34276L12.8111 7.18831C12.5105 6.88776 12.0383 6.86498 11.7111 7.11942Z"
											stroke="#08261B" />
									</svg>Exterior
								</button>
								<button type="button" className={`btn ${generateObj.environment === "Garden" ? "active" : ""}`} onClick={() => handleChangeEnvironment("Garden")} >
									<svg width="26" height="25" viewBox="0 0 26 25" fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<mask id="mask0_133_3622" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse"
											x="0" y="0" width="26" height="25">
											<path d="M25.6666 0H0.666626V25H25.6666V0Z" fill="#08261B" />
										</mask>
										<g mask="url(#mask0_133_3622)">
											<path
												d="M16.9886 10.1526C16.5615 10.516 15.8467 10.7966 15.1329 10.8212L15.0004 10.8235V9.9095C16.0723 9.9095 16.6416 9.32543 16.8223 8.44202L16.832 8.38307C16.8385 8.33371 16.8422 8.2807 16.8441 8.22951L16.8422 8.18701L16.8441 8.0627L16.8432 7.94434"
												fill="#08261B" />
											<path
												d="M16.9886 10.1526C16.5615 10.516 15.8467 10.7966 15.1329 10.8212L15.0004 10.8235V9.9095C16.0723 9.9095 16.6416 9.32543 16.8223 8.44202L16.832 8.38307C16.8385 8.33371 16.8422 8.2807 16.8441 8.22951L16.8422 8.18701L16.8441 8.0627L16.8432 7.94434"
												stroke="#08261B" strokeWidth="0.3" />
											<path
												d="M9.56747 10.3814C9.14036 10.7447 8.42557 11.0253 7.71171 11.05L7.57922 11.0523V10.1383C8.65117 10.1383 9.2205 9.55419 9.40117 8.67078L9.4109 8.61183C9.41738 8.56247 9.42109 8.50946 9.42294 8.45827L9.42109 8.41577L9.42294 8.29146L9.42201 8.1731"
												fill="#08261B" />
											<path
												d="M9.56747 10.3814C9.14036 10.7447 8.42557 11.0253 7.71171 11.05L7.57922 11.0523V10.1383C8.65117 10.1383 9.2205 9.55419 9.40117 8.67078L9.4109 8.61183C9.41738 8.56247 9.42109 8.50946 9.42294 8.45827L9.42109 8.41577L9.42294 8.29146L9.42201 8.1731"
												stroke="#08261B" strokeWidth="0.3" />
											<path
												d="M17.6079 10.126C18.0614 10.5117 18.8378 10.8234 19.6152 10.8234V9.90936L19.5063 9.90799C18.5048 9.8696 17.9674 9.29559 17.7932 8.44234L17.77 8.3418H17.412L17.6079 10.126Z"
												fill="#08261B" stroke="#08261B" strokeWidth="0.3" />
											<path
												d="M10.1868 10.3545C10.6403 10.7402 11.4167 11.0519 12.194 11.0519V10.1379L12.0851 10.1365C11.0836 10.0981 10.5462 9.5241 10.3721 8.67086L10.3489 8.57031H9.99081L10.1868 10.3545Z"
												fill="#08261B" stroke="#08261B" strokeWidth="0.3" />
											<path
												d="M17.6326 10.9136L16.8437 10.9538L16.8298 11.0379C16.6639 11.6375 16.109 12.0579 15 12.0579V12.972L15.1417 12.9701C15.8472 12.9496 16.4156 12.7755 16.8441 12.4903L17.4589 11.9021L17.6326 10.9136Z"
												fill="#08261B" stroke="#08261B" strokeWidth="0.3" />
											<path
												d="M10.2113 11.1416L9.42242 11.1818L9.40852 11.2659C9.24268 11.8655 8.68771 12.286 7.5787 12.286V13.2L7.72046 13.1982C8.42598 13.1776 8.99438 13.0035 9.42288 12.7183L10.0376 12.1301L10.2113 11.1416Z"
												fill="#08261B" stroke="#08261B" strokeWidth="0.3" />
											<path
												d="M17.7701 12.4901C18.2269 12.7944 18.843 12.9717 19.6143 12.9717V12.0577L19.4934 12.0559C18.4645 12.0262 17.9401 11.6158 17.7803 11.0386L17.3639 11.0916L16.9775 11.9631L17.7701 12.4901Z"
												fill="#08261B" stroke="#08261B" strokeWidth="0.3" />
											<path
												d="M10.3489 12.7186C10.8056 13.0229 11.4218 13.2003 12.1931 13.2003V12.2862L12.0722 12.2844C11.0433 12.2547 10.5189 11.8443 10.3591 11.2671L9.94262 11.3201L9.55627 12.1916L10.3489 12.7186Z"
												fill="#08261B" stroke="#08261B" strokeWidth="0.3" />
											<path d="M16.8488 15.5022H17.7878L17.7822 7.94458H16.8428L16.8488 15.5022Z"
												fill="#08261B" stroke="#08261B" strokeWidth="0.3" />
											<path d="M9.42753 15.7307H10.3665L10.361 8.1731H9.42151L9.42753 15.7307Z"
												fill="#08261B" stroke="#08261B" strokeWidth="0.3" />
											<path
												d="M21.0129 15.9366L21.0129 15.0284L5.26257 15.0337L5.26257 15.9424L21.0129 15.9366Z"
												fill="#08261B" stroke="#08261B" strokeWidth="0.3" />
											<path
												d="M13.2924 17.3135C13.8107 17.3139 14.312 17.5013 14.6895 17.8509C14.8702 18.0177 15.1069 18.1178 15.3584 18.1379L15.4539 18.1416V19.0556C14.9355 19.0556 14.4343 18.8678 14.0563 18.5182C13.8534 18.3303 13.5791 18.2275 13.2924 18.2275C13.0052 18.2275 12.7309 18.3303 12.528 18.5182C12.15 18.8678 11.6488 19.0556 11.1304 19.0556C10.6491 19.0556 10.1821 18.8938 9.81571 18.5908L9.73279 18.5182C9.52943 18.3303 9.25565 18.2275 8.96844 18.2275C8.68122 18.2275 8.40745 18.3303 8.20455 18.5182C7.82654 18.8678 7.32484 19.0556 6.80647 19.0556C6.2881 19.0556 5.78687 18.8678 5.40886 18.5182C5.20596 18.3303 4.93218 18.2275 4.64497 18.2275C4.35776 18.2275 4.08398 18.3303 3.88061 18.5182C3.52947 18.8426 3.07225 19.0282 2.59372 19.0529L2.483 19.0556V18.1416C2.73825 18.1416 2.98284 18.0602 3.17694 17.9103L3.24736 17.8509C3.62536 17.5013 4.1266 17.3139 4.64497 17.3135C5.16334 17.3139 5.66457 17.5013 6.04258 17.8509C6.24548 18.0388 6.51926 18.1416 6.80647 18.1416C7.09368 18.1416 7.36746 18.0392 7.57083 17.8509C7.94883 17.5018 8.45007 17.3139 8.96844 17.3135C9.48681 17.3139 9.98804 17.5013 10.366 17.8509C10.5694 18.0388 10.8432 18.1416 11.1304 18.1416C11.4176 18.1416 11.6914 18.0388 11.8943 17.8509C12.2723 17.5013 12.7735 17.3139 13.2924 17.3135Z"
												fill="#08261B" stroke="#08261B" strokeWidth="0.3" />
											<path
												d="M21.6886 17.3135C22.207 17.3139 22.7082 17.5013 23.0858 17.8509C23.2664 18.0177 23.5031 18.1178 23.7547 18.1379L23.8501 18.1416V19.0556C23.3317 19.0556 22.8305 18.8678 22.4525 18.5182C22.2496 18.3303 21.9754 18.2275 21.6886 18.2275C21.4014 18.2275 21.1272 18.3303 20.9243 18.5182C20.5462 18.8678 20.045 19.0556 19.5266 19.0556C19.0453 19.0556 18.5784 18.8938 18.212 18.5908L18.129 18.5182C17.9257 18.3303 17.6519 18.2275 17.3647 18.2275C17.0775 18.2275 16.8037 18.3303 16.6008 18.5182C16.2228 18.8678 15.7211 19.0556 15.2027 19.0556C14.6843 19.0556 14.1831 18.8678 13.8051 18.5182C13.6022 18.3303 13.3284 18.2275 13.0412 18.2275C12.754 18.2275 12.4802 18.3303 12.2769 18.5182C11.9257 18.8426 11.4685 19.0282 10.99 19.0529L10.8792 19.0556V18.1416C11.1345 18.1416 11.3791 18.0602 11.5732 17.9103L11.6436 17.8509C12.0216 17.5013 12.5228 17.3139 13.0412 17.3135C13.5596 17.3139 14.0608 17.5013 14.4388 17.8509C14.6417 18.0388 14.9155 18.1416 15.2027 18.1416C15.4899 18.1416 15.7637 18.0392 15.9671 17.8509C16.3451 17.5018 16.8463 17.3139 17.3647 17.3135C17.883 17.3139 18.3843 17.5013 18.7623 17.8509C18.9657 18.0388 19.2394 18.1416 19.5266 18.1416C19.8139 18.1416 20.0876 18.0388 20.2905 17.8509C20.6685 17.5013 21.1698 17.3139 21.6886 17.3135Z"
												fill="#08261B" stroke="#08261B" strokeWidth="0.3" />
										</g>
									</svg>Garden
								</button>
							</div>
							{generateObj.environment === "interior" &&
								<FormControl fullWidth sx={{ marginTop: "20px" }}>
									<InputLabel id="demo-simple-select-label" sx={{
										color: "#FFF",
										fontSize: "16px",
										fontWeight: "400",
										borderRadius: "8px",
										marginTop: '-3px',
										fontFamily: 'Source Sans Pro',
										"&.Mui-focused": {
											color: "#FFF",
										},
									}}>Room Type</InputLabel>
									<Select
										labelId="demo-simple-select-label"
										id="demo-simple-select"
										value={generateObj.room_type}
										label="Room Type"
										onChange={handleChangeRoomType}
										sx={{
											background: "rgba(255, 255, 255, 0.05)",
											padding: "12px 0px 12px",
											width: "100%",
											color: "#FFF",
											fontSize: "16px",
											fontWeight: "400",
											borderRadius: "8px",
											fontFamily: 'Source Sans Pro',
											height: "50px",
											textOverflow: "ellipsis",
											fontStyle: "normal",
											lineHeight: "22px",

											"&:hover": {
												borderColor: "white"
											},
											'.MuiOutlinedInput-notchedOutline': {
												borderColor: 'rgba(228, 219, 233, 0.25)',
											},
											'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
												borderColor: 'rgba(228, 219, 233, 0.25)',
											},
											'&:hover .MuiOutlinedInput-notchedOutline': {
												borderColor: 'rgba(228, 219, 233, 0.25)',
											},
											"&.Mui-focused": {
												borderColor: "#FFF",

											},
										}}
									>

										{roomType.map((room: any, index: any) => {
											return <MenuItem key={index} sx={{
												display: "block",
												width: "100%",
												fontSize: "16px",
												color: "#FFF",
												background: "#08261B",
												fontWeight: "400",
												fontFamily: 'Source Sans Pro',
												height: "50px",
												textOverflow: "ellipsis",
												padding: "12px 12px",
												fontStyle: "normal",
												"&:focus": {
													backgroundColor: "#FFF",
													color: "#08261B"
												},
												"&:hover": {
													backgroundColor: "#FFF",
													color: "#08261B"
												},
												lineHeight: "22px",
											}} value={room.value}>{room.type} </MenuItem>
										})}
									</Select>
								</FormControl>
							}
							{generateObj.environment === "Exterior" && <>
								<FormControl fullWidth sx={{ marginTop: "20px" }}>
									<InputLabel id="demo-simple-select-label" sx={{
										color: "#FFF",
										fontSize: "16px",
										fontWeight: "400",
										borderRadius: "8px",
										marginTop: '-3px',
										fontFamily: 'Source Sans Pro',
										"&.Mui-focused": {
											color: "#FFF",
										},
									}}>Property Type</InputLabel>
									<Select
										labelId="demo-simple-select-label"
										id="demo-simple-select"
										value={generateObj.property_type}
										label="Property Type"
										onChange={handleChangePropertyType}
										sx={{
											background: "rgba(255, 255, 255, 0.05)",
											padding: "12px 0px 12px",
											width: "100%",
											color: "#FFF",
											fontSize: "16px",
											fontWeight: "400",
											borderRadius: "8px",
											fontFamily: 'Source Sans Pro',
											height: "50px",
											textOverflow: "ellipsis",
											fontStyle: "normal",
											lineHeight: "22px",

											"&:hover": {
												borderColor: "white"
											},
											'.MuiOutlinedInput-notchedOutline': {
												borderColor: 'rgba(228, 219, 233, 0.25)',
											},
											'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
												borderColor: 'rgba(228, 219, 233, 0.25)',
											},
											'&:hover .MuiOutlinedInput-notchedOutline': {
												borderColor: 'rgba(228, 219, 233, 0.25)',
											},
											"&.Mui-focused": {
												borderColor: "#FFF",

											},
										}}
									>

										{propertyType.map((obj: any, index: any) => {
											return <MenuItem key={"property_" + index} sx={{
												display: "block",
												width: "100%",
												fontSize: "16px",
												color: "#FFF",
												background: "#08261B",
												fontWeight: "400",
												fontFamily: 'Source Sans Pro',
												height: "50px",
												textOverflow: "ellipsis",
												padding: "12px 12px",
												fontStyle: "normal",
												"&:focus": {
													backgroundColor: "#FFF",
													color: "#08261B"
												},
												"&:hover": {
													backgroundColor: "#FFF",
													color: "#08261B"
												},
												lineHeight: "22px",
											}} value={obj.value}>{obj.type} </MenuItem>
										})}
									</Select>
								</FormControl>
							</>
							}
							<FormControl fullWidth sx={{ marginTop: "20px" }}>
								<InputLabel id="demo-simple-select-label" sx={{
									color: "#FFF",
									fontSize: "16px",
									fontWeight: "400",
									borderRadius: "8px",
									marginTop: '-3px',
									fontFamily: 'Source Sans Pro',
									"&.Mui-focused": {
										color: "#FFF",
									},
								}}>Change Level</InputLabel>
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									value={generateObj.level}
									label="Change Level"
									onChange={handleChangeLevel}
									sx={{
										background: "rgba(255, 255, 255, 0.05)",
										padding: "12px 0px 12px",
										width: "100%",
										color: "#FFF",
										fontSize: "16px",
										fontWeight: "400",
										borderRadius: "8px",
										fontFamily: 'Source Sans Pro',
										height: "50px",
										textOverflow: "ellipsis",
										fontStyle: "normal",
										lineHeight: "22px",

										"&:hover": {
											borderColor: "white"
										},
										'.MuiOutlinedInput-notchedOutline': {
											borderColor: 'rgba(228, 219, 233, 0.25)',
										},
										'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
											borderColor: 'rgba(228, 219, 233, 0.25)',
										},
										'&:hover .MuiOutlinedInput-notchedOutline': {
											borderColor: 'rgba(228, 219, 233, 0.25)',
										},
										"&.Mui-focused": {
											borderColor: "#FFF",

										},
									}}
								>
									{levelValue.map((room: any, index: any) => {
										return <MenuItem key={"level_" + index} sx={{
											display: "block",
											width: "100%",
											fontSize: "16px",
											color: "#FFF",
											background: "#08261B",
											fontWeight: "400",
											fontFamily: 'Source Sans Pro',
											height: "50px",
											textOverflow: "ellipsis",
											padding: "12px 12px",
											fontStyle: "normal",
											"&:focus": {
												backgroundColor: "#FFF",
												color: "#08261B"
											},
											"&:hover": {
												backgroundColor: "#FFF",
												color: "#08261B"
											},
											lineHeight: "22px",
										}} value={room.value}>{room.type} </MenuItem>
									})}

								</Select>
							</FormControl>
							{generateObj.environment === "interior" && <>
								<FormControl fullWidth sx={{ marginTop: "20px" }}>
									<InputLabel id="demo-simple-select-label" sx={{
										color: "#FFF",
										fontSize: "16px",
										fontWeight: "400",
										borderRadius: "8px",
										marginTop: '-3px',
										fontFamily: 'Source Sans Pro',
										"&.Mui-focused": {
											color: "#FFF",
										},
									}}>Style</InputLabel>
									<Select
										labelId="demo-simple-select-label"
										id="demo-simple-select"
										value={generateObj.style}
										label="Style "
										onChange={handleChangeStyle}
										sx={{
											background: "rgba(255, 255, 255, 0.05)",
											padding: "12px 0px 12px",
											width: "100%",
											color: "#FFF",
											fontSize: "16px",
											fontWeight: "400",
											borderRadius: "8px",
											fontFamily: 'Source Sans Pro',
											height: "50px",
											textOverflow: "ellipsis",
											fontStyle: "normal",
											lineHeight: "22px",

											"&:hover": {
												borderColor: "white"
											},
											'.MuiOutlinedInput-notchedOutline': {
												borderColor: 'rgba(228, 219, 233, 0.25)',
											},
											'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
												borderColor: 'rgba(228, 219, 233, 0.25)',
											},
											'&:hover .MuiOutlinedInput-notchedOutline': {
												borderColor: 'rgba(228, 219, 233, 0.25)',
											},
											"&.Mui-focused": {
												borderColor: "#FFF",

											},
										}}
									>
									
										{style.map((obj: any, index: any) => {
											return <MenuItem key={index} sx={{
												display: "block",
												width: "100%",
												fontSize: "16px",
												color: "#FFF",
												background: "#08261B",
												fontWeight: "400",
												fontFamily: 'Source Sans Pro',
												height: "50px",
												textOverflow: "ellipsis",
												padding: "12px 12px",
												fontStyle: "normal",
												"&:focus": {
													backgroundColor: "#FFF",
													color: "#08261B"
												},
												"&:hover": {
													backgroundColor: "#FFF",
													color: "#08261B"
												},
												lineHeight: "22px",
											}} value={obj.value}>{obj.type} </MenuItem>
										})}
									</Select>
								</FormControl>
								<button className={`generate mar-40 ${(generateObj.room_type && generateObj.style && generateObj?.images?.length !== 0) ? "" : "disabled"}`} onClick={generate}>Generate new Design</button>
							</>
							}
							{generateObj.environment === "Exterior" && <>
								<FormControl fullWidth sx={{ marginTop: "20px" }}>
									<InputLabel id="demo-simple-select-label" sx={{
										color: "#FFF",
										fontSize: "16px",
										fontWeight: "400",
										borderRadius: "8px",
										marginTop: '-3px',
										fontFamily: 'Source Sans Pro',
										"&.Mui-focused": {
											color: "#FFF",
										},
									}}>Style</InputLabel>
									<Select
										labelId="demo-simple-select-label"
										id="demo-simple-select"
										value={generateObj.style}
										label="Style"
										onChange={handleChangeStyle}
										sx={{
											background: "rgba(255, 255, 255, 0.05)",
											padding: "12px 0px 12px",
											width: "100%",
											color: "#FFF",
											fontSize: "16px",
											fontWeight: "400",
											borderRadius: "8px",
											fontFamily: 'Source Sans Pro',
											height: "50px",
											textOverflow: "ellipsis",
											fontStyle: "normal",
											lineHeight: "22px",

											"&:hover": {
												borderColor: "white"
											},
											'.MuiOutlinedInput-notchedOutline': {
												borderColor: 'rgba(228, 219, 233, 0.25)',
											},
											'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
												borderColor: 'rgba(228, 219, 233, 0.25)',
											},
											'&:hover .MuiOutlinedInput-notchedOutline': {
												borderColor: 'rgba(228, 219, 233, 0.25)',
											},
											"&.Mui-focused": {
												borderColor: "#FFF",

											},
										}}
									>
											{generateObj.property_type==="Villa/House" && styleExtVilla.map((obj: any, index: any) => {
											return <MenuItem key={"villa"+index} sx={{
												display: "block",
												width: "100%",
												fontSize: "16px",
												color: "#FFF",
												background: "#08261B",
												fontWeight: "400",
												fontFamily: 'Source Sans Pro',
												height: "50px",
												textOverflow: "ellipsis",
												padding: "12px 12px",
												fontStyle: "normal",
												"&:focus": {
													backgroundColor: "#FFF",
													color: "#08261B"
												},
												"&:hover": {
													backgroundColor: "#FFF",
													color: "#08261B"
												},
												lineHeight: "22px",
											}} value={obj.value}>{obj.type} </MenuItem>
										})}
									{generateObj.property_type==="Building" && styleExtBuil.map((obj: any, index: any) => {
											return <MenuItem key={"build"+index} sx={{
												display: "block",
												width: "100%",
												fontSize: "16px",
												color: "#FFF",
												background: "#08261B",
												fontWeight: "400",
												fontFamily: 'Source Sans Pro',
												height: "50px",
												textOverflow: "ellipsis",
												padding: "12px 12px",
												fontStyle: "normal",
												"&:focus": {
													backgroundColor: "#FFF",
													color: "#08261B"
												},
												"&:hover": {
													backgroundColor: "#FFF",
													color: "#08261B"
												},
												lineHeight: "22px",
											}} value={obj.value}>{obj.type} </MenuItem>
										})}
									</Select>
								</FormControl>
								<button className={`generate mar-40 ${(generateObj.style && generateObj?.images?.length !== 0) ? "" : "disabled"}`} onClick={generate}>Generate new Design</button>
							</>
							}
							{generateObj.environment === "Garden" && <>
								<FormControl fullWidth sx={{ marginTop: "20px" }}>
									<InputLabel id="demo-simple-select-label" sx={{
										color: "#FFF",
										fontSize: "16px",
										fontWeight: "400",
										borderRadius: "8px",
										marginTop: '-3px',
										fontFamily: 'Source Sans Pro',
										"&.Mui-focused": {
											color: "#FFF",
										},
									}}>Style</InputLabel>
									<Select
										labelId="demo-simple-select-label"
										id="demo-simple-select"
										value={generateObj.style}
										label="Style"
										onChange={handleChangeStyle}
										sx={{
											background: "rgba(255, 255, 255, 0.05)",
											padding: "12px 0px 12px",
											width: "100%",
											color: "#FFF",
											fontSize: "16px",
											fontWeight: "400",
											borderRadius: "8px",
											fontFamily: 'Source Sans Pro',
											height: "50px",
											textOverflow: "ellipsis",
											fontStyle: "normal",
											lineHeight: "22px",

											"&:hover": {
												borderColor: "white"
											},
											'.MuiOutlinedInput-notchedOutline': {
												borderColor: 'rgba(228, 219, 233, 0.25)',
											},
											'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
												borderColor: 'rgba(228, 219, 233, 0.25)',
											},
											'&:hover .MuiOutlinedInput-notchedOutline': {
												borderColor: 'rgba(228, 219, 233, 0.25)',
											},
											"&.Mui-focused": {
												borderColor: "#FFF",

											},
										}}
									>
										{styleGarden.map((obj: any, index: any) => {
											return <MenuItem key={index} sx={{
												display: "block",
												width: "100%",
												fontSize: "16px",
												color: "#FFF",
												background: "#08261B",
												fontWeight: "400",
												fontFamily: 'Source Sans Pro',
												height: "50px",
												textOverflow: "ellipsis",
												padding: "12px 12px",
												fontStyle: "normal",
												"&:focus": {
													backgroundColor: "#FFF",
													color: "#08261B"
												},
												"&:hover": {
													backgroundColor: "#FFF",
													color: "#08261B"
												},
												lineHeight: "22px",
											}} value={obj.value}>{obj.type} </MenuItem>
										})}
									</Select>
								</FormControl>
								<button className={`generate mar-40 ${(generateObj.style && generateObj?.images?.length !== 0) ? "" : "disabled"}`} onClick={generate}>Generate new Design</button>
							</>
							}
							{/* <Form.Select className="selectpicker mar-40" onChange={handleChangeNmbGenerations} value={generateObj.number_generations} aria-label="Default select example">
							<option value="">Number of Generations</option>
								<option value="1">1</option>
								<option value="2">2</option>
								<option value="3">3</option>
							</Form.Select> */}
							{/* <div className="form-check">
								<input type="checkbox" className="form-check-input" id="exampleCheck1" onChange={handleChangeInstructions} />
								<label className="form-check-label" htmlFor="exampleCheck1">Write Custom Instructions</label>
							</div> */}

						</div>
					</div>
				</div>
			</div>

		</div>
	)
}

export default GenerateImages;